import React from 'react';
import { Table, TableBody } from 'semantic-ui-react';
import { useSelector } from 'react-redux';
import { AppState } from 'services/types';

// @ts-ignore
import ResponsiveTable from 'components/ResponsiveTable';
import { WorksheetPageIndex } from 'services/worksheet/types';
import PrintFertilizerWorksheetCompletionDetailsTableHeader from './components/FertilizerPrintWorksheetCompletionDetailsTableHeader';
import PrintFertilizerWorksheetCompletionDetailsTableRow from './components/FertilizerPrintWorksheetCompletionDetailsTableRow';
import { makeSelectFertilizerWorksheetEntitySummaries } from './selectors';

export interface OwnProps {
    pageIndex: WorksheetPageIndex;
}

type Props = OwnProps;

export default function FertilizerPrintWorksheetCompletionDetailsTable(
    props: Props
): React.ReactElement {
    const { pageIndex } = props;

    const entitySummaries = useSelector((state: AppState) =>
        makeSelectFertilizerWorksheetEntitySummaries()(state, props)
    );

    return (
        <ResponsiveTable>
            <Table basic="very" className="basic-table" unstackable>
                <PrintFertilizerWorksheetCompletionDetailsTableHeader />
                <TableBody>
                    {entitySummaries &&
                        entitySummaries.map((entitySummary, index) => (
                            <PrintFertilizerWorksheetCompletionDetailsTableRow
                                entitySummaryIndex={index}
                                pageIndex={pageIndex}
                                key={index} // eslint-disable-line react/no-array-index-key
                            />
                        ))}
                </TableBody>
            </Table>
        </ResponsiveTable>
    );
}
